var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.65 8.16H13.84V5.88C13.83 3.74 12.11 2 10 2C7.88 2 6.16 3.74 6.16 5.88V8.15H5.35C4.74 8.15 4.25 8.64 4.25 9.25V16.89C4.25 17.5 4.74 17.99 5.35 17.99H14.65C15.26 17.99 15.75 17.5 15.75 16.89V9.26C15.75 8.65 15.26 8.16 14.65 8.16ZM7.16 5.88C7.16 4.29 8.44 3 10 3C11.56 3 12.83 4.29 12.83 5.88V8.15H7.16V5.88ZM14.75 16.9C14.75 16.96 14.71 17 14.65 17H5.35C5.3 17 5.25 16.96 5.25 16.9V9.26C5.25 9.2 5.29 9.16 5.35 9.16H14.65C14.71 9.16 14.75 9.2 14.75 9.26V16.9Z",
    fill: "#0E6A8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.aacdd97a7ff91affb2d5e11949810575.svg";
export { ForwardRef as ReactComponent };